import React, { useState } from 'react';
import { X, XCircle } from 'lucide-react';
import { MessageModal } from './MessageModal';
interface RejectListingModalProps {
  isOpen: boolean;
  onClose: () => void;
  listingId: string;
  listingTitle: string;
}
export function RejectListingModal({
  isOpen,
  onClose,
  listingId,
  listingTitle
}: RejectListingModalProps) {
  const [reason, setReason] = useState('');
  const [selectedReasons, setSelectedReasons] = useState<string[]>([]);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  if (!isOpen) return null;
  const commonReasons = ['Incomplete documentation', 'Invalid legal clearances', 'Pricing not within guidelines', 'Property details inaccurate', 'Duplicate listing', 'Fraudulent information detected'];
  const toggleReason = (reasonText: string) => {
    setSelectedReasons(prev => prev.includes(reasonText) ? prev.filter(r => r !== reasonText) : [...prev, reasonText]);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedReasons.length === 0 && !reason.trim()) {
      alert('Please select or enter a reason for rejection');
      return;
    }
    setIsMessageModalOpen(true);
    setTimeout(() => {
      onClose();
      setReason('');
      setSelectedReasons([]);
    }, 2000);
  };
  return <>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-715">
        <div className="bg-white border border-gray-300 max-w-lg w-full shadow-lg" data-id="element-716">
          <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-717">
            <h3 className="font-bold text-lg flex items-center gap-2" data-id="element-718">
              <XCircle className="w-5 h-5 text-red-600" data-id="element-719" />
              Reject Listing
            </h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-720">
              <X className="w-5 h-5" data-id="element-721" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-4" data-id="element-722">
            <div className="p-3 bg-gray-50 border border-gray-200" data-id="element-723">
              <p className="text-sm text-gray-600" data-id="element-724">Listing ID:</p>
              <p className="font-bold font-mono" data-id="element-725">{listingId}</p>
              <p className="text-sm text-gray-600 mt-2" data-id="element-726">Title:</p>
              <p className="font-bold" data-id="element-727">{listingTitle}</p>
            </div>

            <div data-id="element-728">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-729">
                Reason for Rejection
              </label>
              <div className="space-y-2 mb-4" data-id="element-730">
                {commonReasons.map(reasonText => <label key={reasonText} className="flex items-center gap-2 cursor-pointer" data-id="element-731">
                    <input type="checkbox" checked={selectedReasons.includes(reasonText)} onChange={() => toggleReason(reasonText)} className="w-4 h-4" data-id="element-732" />
                    <span className="text-sm text-gray-700" data-id="element-733">{reasonText}</span>
                  </label>)}
              </div>
            </div>

            <div data-id="element-734">
              <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-735">
                Additional Details
              </label>
              <textarea value={reason} onChange={e => setReason(e.target.value)} placeholder="Provide specific details about the rejection..." rows={4} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500 text-sm" data-id="element-736" />
            </div>

            <div className="p-3 bg-red-50 border border-red-200 text-xs text-red-900" data-id="element-737">
              <p className="font-bold mb-1" data-id="element-738">Note:</p>
              <p data-id="element-739">
                The seller will be notified of this rejection and the reasons
                provided. They can resubmit after addressing the issues.
              </p>
            </div>

            <div className="flex justify-end gap-3 pt-4" data-id="element-740">
              <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-741">
                Cancel
              </button>
              <button type="submit" className="px-4 py-2 bg-red-600 text-white text-sm font-bold hover:bg-red-700" data-id="element-742">
                Reject Listing
              </button>
            </div>
          </form>
        </div>
      </div>

      <MessageModal isOpen={isMessageModalOpen} onClose={() => setIsMessageModalOpen(false)} title="Listing Rejected" message={`Listing ${listingId} has been rejected. The seller has been notified with the reasons and can resubmit after corrections.`} type="error" data-id="element-743" />
    </>;
}